// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger-menu-item {
  display: flex;
  flex-direction: row;
  width: 95%;
  height: 40px;
  background-color: ghostwhite;
  border-color: rgb(81, 158, 202);
  border-width: 1px;
  border-style: solid;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(167, 167, 167, 0.445);
}
`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/MenuItem/MenuItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kDAAkD;AACpD","sourcesContent":[".hamburger-menu-item {\n  display: flex;\n  flex-direction: row;\n  width: 95%;\n  height: 40px;\n  background-color: ghostwhite;\n  border-color: rgb(81, 158, 202);\n  border-width: 1px;\n  border-style: solid;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  box-shadow: 1px 1px 1px rgba(167, 167, 167, 0.445);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
